// ------ SHARED ------
export interface ILink {
  Name: string
  Target: string
  Url: string
}

export interface IChallengeHighlight {
  Heading: string
  ImageUrl: string
  Link: ILink
  Teaser: string
}

export interface IArticleItem {
  ImageUrl: string
  ImageAltText: string
  Heading: string
  Teaser: string
  Link: string
  Area: string
  Date: string
}

export interface IImage {
  Url: string
  Alt: string
}

// ------ MENU ------

export interface IMenuLeftSide {
  Heading: string
  ImageUrl: string
  Link: ILink
  Text: string
  SubLinks: ILink[]
}

export interface IInfoBox {
  Heading: string
  Link: ILink
  Teaser: string
}

export interface IMenuItem {
  Highlight: boolean
  IsDirectLink: boolean
  LinkUrl: string
  MenuTitle: string
  LeftSide: IMenuLeftSide
  RightSide: (
    | { LinkList: ILink[] }
    | IChallengeHighlight
    | { Tabs: ITabMenu[] }
  )[]
  InfoBox?: IInfoBox
}

export interface ITabMenu {
  Items: ({ LinkList: ILink[] } | IChallengeHighlight)[]
  LinkLabel: string
}

export interface IMenuContent {
  MenuItems: IMenuItem[]
}

export interface ILanguageContent {
  Name: string
  Url: string
}

export interface ISearchContent {
  ChallengeHighlights: IChallengeHighlight[]
  PopularSearchTerms: string[]
  PopularSearchTitle: string
  SearchUrl: string
  CloseButtonText: string
  PlaceholderText: string
}

export interface IHeaderContent {
  headerContent: IMenuContent
  languageItems: ILanguageContent[]
  search: ISearchContent
}

// ------ ACCORDION ------

export interface IDownloadAccordionContentItem {
  Title: string
  Text?: string
  Files?: ILink[]
  File?: ILink
  AudioFile?: ILink
  PresentationFile?: ILink
}
export interface IDownloadAccordionContent {
  DownloadButtonLabel: string
  Items: IDownloadAccordionContentItem[]
}

export interface IWhitePaperAccordionItems {
  Content: string
  Heading: string
  PaperNumber: string
  PaperUrl: string
}
export interface IWhitePaperAccordionContent {
  LinkText: string
  LoadMore: string
  AllLabel: string
  Items: IWhitePaperAccordionItems[]
  Filters: IFilterOverview[]
}

export interface IRteAccordionItems {
  Content: string
  Heading: string
}
export interface IRteAccordionContent {
  Heading: string
  Items: IRteAccordionItems[]
}

// ------ NEWS OVERVIEW ------

export interface IOverviewItem {
  ImageUrl: string
  ImageAltText: string
  Heading: string
  Teaser: string
  Link: string
  Area: string
  Date: string
}

export interface INewsOverview {
  TotalCount: number
  Articles: IArticleItem[]
  Filters: string[]
}

export interface INewsOverviewContent {
  NewsOverview: INewsOverview
  NewsAllLabel: string
  NewsHeading: string
  ArticleLinkLabel: string
}

export interface IFilterOverview {
  FilterName: string
  PropertyToMatch: string
  UseAsTabs: boolean
  Values: string[]
}

export interface IOverview {
  TotalCount: number
  Items: IOverviewItem[]
  Filters: IFilterOverview[]
}

export interface IOverviewContent {
  Overview: IOverview
  AllLabel: string
  Heading: string
  LinkLabel: string
}
// ------ PRODUCT OVERVIEW ------
export interface IItemOverviewContent {
  Overview: IOverview
  AllLabel: string
  Heading: string
  LinkLabel: string
  PageNodeId: string
  Culture: string
  LoadMore: string
}

export interface IAnswerOverviewApi {
  filters: string
  items: IItemOverviewApi[]
  page: number
  pageSize: number
  totalCount: number
}
export interface IItemOverviewApi {
  imageUrl: string
  imageAltText: string
  heading: string
  teaser: string
  link: string
  area: string
  date: string
}

// ------ CONTACT OVERVIEW ------
export interface IContactPersons {
  name: string
  email: boolean
  imageUrl: string
  linkedInUrl: string
  phone: string
  title: string
  office?: string
}
export interface IOffices {
  name: string
  isMainOffice: boolean
  country: string
  contactPersons: IContactPersons[]
}
export interface IRegions {
  name: string
  contactPersons: IContactPersons[]
}
export interface IContact {
  countryFilter: string[]
  regionFilter: string[]
  regions: IRegions[]
  activeRegion: string
}

export interface IContactContent {
  Overview: IContact
  CountryFilterLabel: string
  Heading: string
  RegionFilterLabel: string
  Culture: string
}

// ------ TAB NAVIGATION OVERVIEW ------

export interface ITabLink {
  Href: string
  Rel: string
  Target: string
  Text: string
  Title: string
}
export interface ITabItems {
  Heading: string
  Image: IImage
  Links: ITabLink[]
  Link: ITabLink
}

export interface ITabNavigationContent {
  Heading: string
  AllLabel: string
  TabItems: ITabItems[]
}

// ------ ENUM ------

export enum LINK_STYLE_ENUM {
  TEXT = 'link-text',
  CHEVRON = 'link-chevron-right',
}

export enum DEVICES_EUM {
  DESKTOP = 'desktop',
  MOBILE = 'mobile',
}
